import { queueTask } from "./queueTask";

/**
 * Cooperative multitasking primitive for yielding control back to the event loop.
 * Example use case:
 *  Allow processing of MessageEvent that signals aborting an operation in progress
 *  that otherwise would proceed uninterrupted.
 */
export function yieldToEventLoop(signal?: AbortSignal) {
  return new Promise<void>((resolve, reject) => {
    queueTask(function completeYield() {
      try {
        signal?.throwIfAborted();
        resolve();
      } catch (err: unknown) {
        const error =
          err instanceof Error ? err : new Error(String(err), { cause: err });
        reject(error);
      }
    });
  });
}
